module.exports = __webpack_public_path__ + "static/media/grid_img4.97c76fd0.webp";